import React from 'react';
import { Col, Row, Table } from 'reactstrap';
import { ProductConfigurationReportDto } from '../../requests/useGetProductConfigurationReport';

export const reportColumns = [
  'Sites',
  'Product',
  'Density'
]

interface ProductConfigurationReportDisplayProps {
  reportData: ProductConfigurationReportDto[];
  downloadQuery: () => Promise<void>;
  columns: string[];
}

export const ProductConfigurationReportDisplay: React.FC<ProductConfigurationReportDisplayProps> = ({ reportData, downloadQuery, columns }) => {
  const columnDisplayState = reportColumns.map(rc => ({ name: rc, show: columns.includes(rc) }))
  const isColumnSelected = (name: string) => columnDisplayState.find(c => c.name === name)!.show;

  return (
    <div className="container-fluid p-4">
      <Row>
        <Col className="col-auto pe-0">
          <h1 className="ka-blue">Product Configuration Report</h1>
        </Col>
        <Col className="px-0">
          <button className="btn py-0 px-3" onClick={() => downloadQuery()} data-testid="download">
            <i className="bi bi-cloud-download ka-blue" style={{ fontSize: "2em" }} />
          </button>
        </Col>
      </Row>
      <p className="text-muted">Generated on {new Date().toLocaleString()}</p>
      {reportData.length > 0 ? (
        <div className="table">
          <Table borderless>
            <thead className="sticky-top bg-white">
              <tr className="border-bottom border-dark border-1">
                {isColumnSelected("Sites") && <th>Sites</th>}
                {isColumnSelected("Product") && <th>Product</th>}
                {isColumnSelected("Density") && <th>Density</th>}
              </tr>
            </thead>
            <tbody>
              {reportData.map(product => (
                <tr key={product.product} className="border-top">
                  {isColumnSelected("Sites") && <td className="py-1 text-nowrap">{product.sites}</td>}
                  {isColumnSelected("Product") && <td className="py-1 text-nowrap">{product.product}</td>}
                  {isColumnSelected("Density") && <td className="py-1 text-nowrap">{product.density}</td>}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      ) : (
        <div className="text-center py-5 text-muted">
          <i className="bi bi-inbox fs-1 d-block mb-3"></i>
          <h4>No Data Available</h4>
          <p>No order transactions found for this business.</p>
        </div>
      )}
    </div>
  );
};